module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-filelist",
    class: {
      'no-data': _vm.list.length == 0
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.titleIcon,
      "color": "#fff",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right-top", function() {
    return [(_vm.showButtons) ? _c('el-upload', {
      ref: "upload",
      attrs: {
        "show-file-list": false,
        "on-success": _vm.handleSuccess,
        "before-upload": _vm.beforeUpload,
        "http-request": _vm.uploadFile,
        "file-list": _vm.fileList,
        "action": ""
      }
    }, [_c('rt-button', {
      attrs: {
        "icon-name": "rt-base-upload",
        "type": "primary"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$tx('上传文件', 'xpc.uploadfile.uploadfile')) + "\n          ")])], 1) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.list.length > 0) ? _c('el-table', {
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$tx('文件名称', 'xpc.uploadfile.filename'),
      "sortable": "",
      "prop": "name",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          _vm.uploadFlag == true &&
          scope.row.uploadPercent > 0 &&
          scope.row.uploadPercent != 100
        ) ? _c('div', {
          staticClass: "progress-box"
        }, [_c('el-progress', {
          attrs: {
            "percentage": scope.row.uploadPercent,
            "show-text": false
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "progress"
        }, [_vm._v("\n              " + _vm._s(_vm.$tx(
          ("已上传" + (scope.row.uploadPercent)),
          'xpc.uploadfile.uploaded', {
            count: scope.row.uploadPercent
          }
        )) + "%\n            ")])], 1) : _vm._e(), _vm._v(" "), (!scope.row.isEdit) ? _c('div', {
          staticClass: "noEdit"
        }, [(_vm.isImage(scope.row.name)) ? _c('rt-popover', {
          attrs: {
            "popper-class": "rt-upload-slide-image",
            "placement": "left",
            "trigger": "hover"
          }
        }, [(_vm.isImage(scope.row.name)) ? _c('rt-image-preview', {
          attrs: {
            "src": scope.row.url,
            "preview-src-list": [scope.row.url]
          }
        }) : _c('rt-icon', {
          attrs: {
            "name": _vm.iconName(scope.row.name),
            "color": _vm.iconColor(scope.row.name),
            "size": "28"
          }
        }), _vm._v(" "), (_vm.isImage(scope.row.name)) ? _c('rt-image-preview', {
          staticStyle: {
            "width": "28px",
            "height": "28px"
          },
          attrs: {
            "slot": "reference",
            "src": scope.row.url,
            "preview-src-list": [scope.row.url]
          },
          slot: "reference"
        }) : _c('rt-icon', {
          attrs: {
            "slot": "reference",
            "name": _vm.iconName(scope.row.name),
            "color": _vm.iconColor(scope.row.name),
            "size": "28"
          },
          slot: "reference"
        })], 1) : _c('rt-icon', {
          attrs: {
            "name": _vm.iconName(scope.row.name),
            "color": _vm.iconColor(scope.row.name),
            "size": "24"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "name",
          on: {
            "click": function($event) {
              return _vm.itemClick(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])], 1) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.$tx('请填写文件名称', 'xpc.uploadfile.filenameplaceholder')
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        })], 1)]
      }
    }], null, false, 1384539190)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('文件大小', 'xpc.uploadfile.filesize'),
      "sortable": "",
      "prop": "size",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.size) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.fileSize(scope.row.size)) + "\n          ")]) : _vm._e()]
      }
    }], null, false, 3413568551)
  }), _vm._v(" "), (_vm.showTitle) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('标题', 'xpc.uploadfile.title'),
      "sortable": "",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEdit) ? _c('p', [_vm._v("\n            " + _vm._s(scope.row.title) + "\n          ")]) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.$tx('请填写标题名称', 'xpc.uploadfile.titleplaceholder')
          },
          model: {
            value: (scope.row.title),
            callback: function($$v) {
              _vm.$set(scope.row, "title", $$v)
            },
            expression: "scope.row.title"
          }
        })], 1)]
      }
    }], null, false, 2010385863)
  }) : _vm._e(), _vm._v(" "), (_vm.showRemark) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('备注', 'xpc.uploadfile.remark'),
      "sortable": "",
      "prop": "remark"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEdit) ? _c('p', [_vm._v("\n            " + _vm._s(scope.row.remark) + "\n          ")]) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.$tx('请填写备注', 'xpc.uploadfile.remarkplaceholder'),
            "type": "textarea"
          },
          model: {
            value: (scope.row.remark),
            callback: function($$v) {
              _vm.$set(scope.row, "remark", $$v)
            },
            expression: "scope.row.remark"
          }
        })], 1)]
      }
    }], null, false, 1708758508)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('操作', 'xpc.uploadfile.operate'),
      "sortable": "",
      "prop": "operation",
      "align": "left",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operation"
        }, [_c('rt-list-button-group', {
          attrs: {
            "max-btns": 4
          }
        }, [(!scope.row.isEdit && _vm.showEdit) ? _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$tx('编辑', 'xpc.uploadfile.edit')) + "\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.isEdit && _vm.showEdit) ? _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.save(scope)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$tx('保存', 'xpc.uploadfile.save')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.showDownload) ? _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.$index, scope)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$tx('下载', 'xpc.uploadfile.download')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.showDelete) ? _c('rt-popconfirm', {
          attrs: {
            "title": _vm.$tx(
              '确定需要删除这条内容吗？',
              'xpc.uploadfile.confirmdelete'
            )
          },
          on: {
            "confirm": function($event) {
              return _vm.onConfirm(scope.row.name, scope.$index)
            }
          }
        }, [_c('rt-button', {
          attrs: {
            "slot": "reference",
            "text": "",
            "type": "plain"
          },
          slot: "reference"
        }, [_vm._v("\n                  " + _vm._s(_vm.$tx('删除', 'xpc.uploadfile.delete')) + "\n                ")])], 1) : _vm._e()], 1)], 1)]
      }
    }], null, false, 706203602)
  })], 1) : _vm._t("empty", function() {
    return [_c('rt-default-image', {
      attrs: {
        "size": "medium"
      }
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_vm._v("\n          " + _vm._s(_vm.$tx('暂无数据', 'xpc.uploadfile.nodata')) + "\n        ")])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b45d7f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/uploadFilelist/rtUploadFilelist.vue
// module id = 2096
// module chunks = 228